import {
  AudioRecorder,
  LiveViewSwitch,
} from '@hakimo-ui/hakimo/feature-shared';
import { CameraDetail } from '@hakimo-ui/hakimo/types';
import { trackEvent } from '@hakimo-ui/hakimo/util';
import { SignalIcon } from '@heroicons/react/24/outline';

interface Props {
  camera: CameraDetail;
}

export function LiveSection(props: Props) {
  const { camera } = props;

  const onTalkdown = (cameraId: string) => {
    trackEvent('submit_camera_details_audio_talkdown', {
      camera_id: cameraId,
    });
  };

  return (
    <div className="bg-onlight-bg-1 dark:bg-ondark-bg-1 relative rounded-lg p-6">
      <div className="mb-4 flex items-center gap-2">
        <SignalIcon className="text-onlight-text-2 dark:text-ondark-text-2 h-5 w-5" />
        <h3 className="text-onlight-text-1 dark:text-ondark-text-1 text-base font-semibold">
          Live
        </h3>
      </div>
      {camera.audioDeviceMapped && (
        <div className="absolute right-4 top-4 mb-4">
          <AudioRecorder
            cameraId={camera.id}
            onTalkdown={onTalkdown}
            cameraName={camera.name}
          />
        </div>
      )}
      <div className="overflow-hidden rounded-lg">
        <LiveViewSwitch
          cameraId={camera.id}
          livestreamUrl={camera.livestreamUrl}
        />
      </div>
    </div>
  );
}

export default LiveSection;
